export enum SessionStorage {
  HasViewedWarning = 'HAS_VIEWED_WARNING',
  Organization = 'ORG',
  Language = 'LANG',
  ParentUrl = 'PARENT_URL',
  Country = 'COUNTRY',
  StudentPhoneNumber = 'STUDENT_PHONE_NUMBER',
  ServicePhoneNumber = 'SERVICE_PHONE_NUMBER'
}
